<template>
<div class='chooseCompanyWrapper'>
  <div class="chooseCompany">
    <div class="logoBanerWrapper">
      <img :src="pageStyleConfig.bannerImg||bannerBac" class="logoBanner" />
    </div>
    <div>
    <div class='inputContainerWrapperBlock' 
   :style="[{'backgroundColor':(pageStyleConfig.bgType==0?pageStyleConfig.inputBgWrapperColor:'#fff')},
            {'backgroundImage':`url(${pageStyleConfig.inputBgPic})`}]"
       
   >
    <div class="inputContainerWrapper">
      <div class="inputContainer">
        <div class="inputInnerContainer" :style="{'--inputBgColor':pageStyleConfig.inputBgColor}">
          <label class="input-label" :style="{'--inputColor':pageStyleConfig.inputColor}">公司名称</label>
          <div class="companyWrapeper">
            <input
              type="text"
              class="company-name"
              id='companyName'
              placeholder="请输入公司名称"
              maxlength="60"
              v-model="companyName"
              @focus="companyNameFocus(1)"
              @blur="companyNameBlur(1)"
              @input="handleInput(1)"
              @compositionstart="companyNameCompositionstart(1)"
              @compositionend="companyNameCompositionend(1)"
              @compositionupdate="companyNameCompositionupdate(1)"
              :style="{'--placeColor':pageStyleConfig.inputColor,'--inputBgColor':pageStyleConfig.inputBgColor}"
            />
          </div>
        </div>
        <ul class="companyList" v-show="companyNameListShow&&listCompany.length>0">
          <li
            class='companyItem'
            v-for="(item, index) in listCompany"
            :key="index"
            @click="chooseCompanyName(item, 1)"
          >
            {{ item.name }}
          </li>
        </ul>
      </div>
    </div>
    <button class="downloadBtn linear" @click="downLoadReport(1)" :disabled='oneDis'
    :style="[{'--buttonColor':pageStyleConfig.buttonBgColor},{'--buttonTxtColor':pageStyleConfig.buttonColor}]"
    >
      <span class='point'><img src='../../assets/point1.png' class='pointImg'/>免费</span>获取企业价值报告
      </button>
    <div class="alreadyVal">
      <img src="../../assets/alreadyWan.png" class="alreaadyValPic" v-show="!sparams||!pageStyleConfig.isSuccessRes"/>
    </div>
  </div>
  </div>
    <div class="problemuse" v-show="!sparams||!pageStyleConfig.isSuccessRes">
      <img :src="aboutMoguguUSe"  class='valuationToMogugu'/>
      <!-- <div class="problemTittle">
        <span class="grayColor">您是否存在</span
        ><span class="blueColor">以下问题</span>
      </div>
      <div class="problemEn">HAVE YOU MET THE FOLLOWING PROBLEMS</div>
      <div>
        <div class="problemText">
          <div class="textBlock marginBto">评估周期长?</div>
          <div class="textBlock marginBto">流程太繁琐?</div>
          <div class="textBlock marginBto">评估不专业?</div>
          <div class="textBlock">收费不合理?</div>
        </div>
        <div class="perImg">
          <img src="../../assets/problemPerson.png" class="problemPer" />
        </div>
      </div> -->
    </div>
    <div class="problem" v-show="sparams">
      <img :src="pageStyleConfig.ImgArr[0]"  class='valuationToMogugu'/>
    </div>
    <!-- <div class="aboutMogugu">
      <div class="aboutmoguguImgWrapper">
        <img src="../../assets/aboutMogugu.png" class="aboutmoguguImg" />
      </div>
    </div> -->
    <div class="VSBlock" v-show="!sparams||!pageStyleConfig.isSuccessRes">
      <div class="VStitle">模估估VS其他估值服务</div>
      <div class="vsTipWrapper">
        <div class='vsleft'>
        <span class="vsTipL">传统估值</span>
        </div>
        <span class='vscenter'></span>
        <div class="vsright">
        <span class="vsTip">模估智能</span>
        </div>
      </div>
      <div class="vsContent">
        <div class="vsContentItem">
          <div class="vsImgWrapper">
            <img src="../../assets/vsleftOne1.jpg" class="vsImgC" />
          </div>
          <div class="vsImgTitle grayColor">费用高，时间长</div>
          <div class="vsImgSpeak grayColor">需要雇佣专业机构或人员</div>
          <div class="vsImgSpeak grayColor">费用高昂</div>
          <div class="vsImgSpeak marBto36 grayColor">花费较长时间</div>
          <div class="vsImgWrapper">
            <img src="../../assets/vsleftTwo1.jpg" class="vsImgC" />
          </div>
          <div class="vsImgTitle grayColor">无法智能更新</div>
          <div class="vsImgSpeak grayColor">每次只能基于某个固定时点</div>
          <div class="vsImgSpeak marBto36 grayColor">不能根据最新信息更新估值</div>
          <div class="vsImgWrapper">
            <img src="../../assets/vsleftThree1.jpg" class="vsImgC" />
          </div>
          <div class="vsImgTitle grayColor">评估结果主观</div>
          <div class="vsImgSpeak grayColor">人力可获取信息有限</div>
          <div class="vsImgSpeak grayColor">估值人员可能存在主观立场</div>
          <div class="vsImgSpeak marBto36 grayColor">每次估值评价标准不同</div>
        </div>
        <div class="vsContentItemCenter">
          <div class="vsCenterV">V</div>
          <img src="../../assets/vsCenter.png" class="vsContentImg" />
          <div class="vsCenterS">S</div>
        </div>
        <div class="vsContentItem">
          <div class="vsImgWrapper">
            <img src="../../assets/vsRightOne.png" class="vsImgC" />
          </div>
          <div class="vsImgTitle">普惠</div>
          <div class="vsImgSpeak">不懂估值也能自助完成</div>
          <div class="vsImgSpeak">免费开放</div>
          <div class="vsImgSpeak marBto36">立刻可得结果和报告</div>
          <div class="vsImgWrapper">
            <img src="../../assets/vsRightTwo.png" class="vsImgC" />
          </div>
          <div class="vsImgTitle">时效</div>
          <div class="vsImgSpeak">每周根据最新信息自动重估</div>
          <div class="vsImgSpeak marBto36">可以长期跟踪企业估值变动</div>
          <div class="vsImgWrapper">
            <img src="../../assets/vsRightThree.png" class="vsImgC" />
          </div>
          <div class="vsImgTitle">公允</div>
          <div class="vsImgSpeak">以大数据为依据</div>
          <div class="vsImgSpeak">人工智能保证独立客观</div>
          <div class="vsImgSpeak marBto36">评价标准统一</div>
        </div>
      </div>
    </div>
    <div class="problem" v-show="sparams&&pageStyleConfig.ImgArr[1]">
        <img :src="pageStyleConfig.ImgArr[1]"  class='valuationToMogugu'/>
     </div>
    <div class="reportBlock" v-show="!sparams||!pageStyleConfig.isSuccessRes">
      <div class="reportTitle"><span class='oneKey'>一键投递</span><span class="oneKey plus">30+投资机构</span></div>
      <div class="reportPicWrapper">
        <img src="../../assets/report1.png" class="reportPic" />
      </div>
    </div>
    <div class="problem" v-show="sparams&&pageStyleConfig.ImgArr[2]">
        <img :src="pageStyleConfig.ImgArr[2]"  class='valuationToMogugu'/>
     </div>
    <div class="wxReportExample" v-show="!sparams||!pageStyleConfig.isSuccessRes">
      <div class="reportExampleTitle">网信报告案例</div>
      <div class="reportExample">
        <img src="../../assets/wxReport.png" class="wxReport" />
      </div>
    </div>
    <div class="problem" v-show="sparams&&pageStyleConfig.ImgArr[3]">
        <img :src="pageStyleConfig.ImgArr[3]"  class='valuationToMogugu'/>
     </div>
     <div class="problem" v-if="sparams&&pageStyleConfig.ImgArr[4]">
        <img :src="pageStyleConfig.ImgArr[4]"  class='valuationToMogugu'/>
     </div>
    <!-- <div class="twoCodeBlock">
      <div class="twoCodeTitle">联系我们</div>
      <div class="twoCode">
        <img src="../../assets/twoCode.png" class="twoCodeImg" />
      </div>
      <div class="fllow">关注我们获取更多估值知识和商业资讯</div>
    </div> -->
    <div v-if="!sparams||!pageStyleConfig.isSuccessRes">
    <a class='bottomBannerWrapper' href="https://mp.weixin.qq.com/s/QMoqBsUdlVQO273KG38DoQ">
      <img src='../../assets/bannerBottom.jpg' class='bannerBottomImg'/>
    </a>
    <a class="linkSpeakWrap" href="https://mp.weixin.qq.com/s/QMoqBsUdlVQO273KG38DoQ">
      <div class='linkSpeak'>
         <img src='../../assets/pointTwo.jpg' class='pointTwo'/>
         点击了解与新经济时代的企业估值相关的详细内容...
      </div>
    </a>
    <div class='relateUs'>联系我们</div>
    <div class='relatePicWrapper'>
      <span class='hotLine'>
        <img src='../../assets/callPhone.jpg' class='relatePic' />
      热线&nbsp;|
      </span>
      <a class='telNumber' href="tel:021-60297570">021-60297570</a>
      </div>
    <div class='welcomeTel'>欢迎致电，解锁更多福利~</div>
    </div>
    <div class='bottomButtonbg' :style="[{'backgroundColor':(pageStyleConfig.bgType==0?pageStyleConfig.inputBgWrapperColor:'#fff')},
            {'backgroundImage':`url(${pageStyleConfig.inputBgPic})`}]" v-show='!sparams||!pageStyleConfig.isSuccessRes'>
    <div>
      <div class="inputContainer">
        <div class="inputInnerContainer" :style="{'--inputBgColor':pageStyleConfig.inputBgColor}">
          <label class="input-label" :style="{'--inputColor':pageStyleConfig.inputColor}">公司名称</label>
          <div class="companyWrapeper">
            <input
              :style="{'--placeColor':pageStyleConfig.inputColor,'--inputBgColor':pageStyleConfig.inputBgColor}"
              type="text"
              class="company-name"
              id='companyName'
              placeholder="请输入公司名称"
              maxlength="60"
              v-model="companyNameB"
              @focus="companyNameFocus()"
              @blur="companyNameBlur()"
              @input="handleInput()"
              @compositionstart="companyNameCompositionstart()"
              @compositionend="companyNameCompositionend()"
              @compositionupdate="companyNameCompositionupdate()"
            />
          </div>
        </div>
        <ul class="companyList" v-show="companyNameListShowB&&listCompany.length">
          <li
            class='companyItem'
            v-for="(item, index) in listCompany"
            :key="index"
            @click="chooseCompanyName(item)"
          >
            {{ item.name }}
          </li>
        </ul>
      </div>
    </div>
    <button class="downloadBtn" :disabled='twoDis' @click="downLoadReport()"
    :style="[{'--buttonColor':pageStyleConfig.buttonBgColor},{'--buttonTxtColor':pageStyleConfig.buttonColor}]"
    >免费获取网信报告</button>
    <div class='moreBlock'></div>
  </div>
  </div>
  <div v-if="loadingShow">
      <loading-com />
    </div>
    <Dialog
      :type="getReportType"
      :errMsg="getReportRes"
      @dialogGoBack="dialogGoBack"
      v-if="dialogShow"
    />
    <Searching v-if='isSearchingShow'/>
</div>
</template>

<script>
import { Button } from "vant";
import debounce from "../../utils/debounce";
import Dialog from "../../components/dialog/dialog.vue";
import Searching from '../../components/searching/searching.vue'
import shareImpl from '../../utils/wxApi'
import { searchEnterprise2, checkEnterpriseName ,downloadSystemInputReport} from "@/api/api.js";
import Vue from "vue";
import loadingCom from "@/components/getReportLoading/reportLoading.vue";
import bannerBac from '../../assets/logoBanner.jpg'
import aboutMoguguUSe from '../../assets/aboutMoguguUSe.png'

Vue.use(loadingCom);
export default {
  name: "chooseCompany",
  components: {
    vanButton: Button,
    loadingCom: loadingCom,
    Dialog,
    Searching,
  },
  data() {
    return {
      listCompany: [],
      companyName: "",
      companyNameListShow: false,
      loadingShow: false,
      compositionFlag: false,
      companyNameB: "",
      companyNameListShowB: false,
      compositionFlagB: false,
      reportId: "",
      reportIdB:'',
      getReportType: "",
      getReportRes: "",
      dialogShow: false,
      oneDis:true,
      twoDis:true,
      isSearchingShow:false,
      newDebounce:()=>{},
      shareCan:'',
      bannerBac:bannerBac,
      aboutMoguguUSe:aboutMoguguUSe,
      sparams:this.$route.query.s,
      // placeColor:'#969caa',

      // pageStyleConfig:{}
      // style
    };
  },
  created() {
    document.addEventListener('click', this.outCompanyClick, false)
    // shareImpl({shareTitle:'分享测试',
    //            shareDesc: '分享测试描述',
    //            shareUrl: location.href,
    //            shareImg: 'https://rdt.h5.mogugu.com/static/img/bannerBottom.ef9f362.jpg'
    //                 })
  },
  mounted() {
    // console.log("loadingCom", loadingCom);
    // console.log('test',this.test)
    this.sparams = this.$route.query.s
    console.log('route',this.sparams)

    this.shareCan = 'share'
    console.log('pageStyleConfigmount',this.pageStyleConfig)
    this.newDebounce = debounce(this.searchEnterprise2Fun,300)

  },
  beforeDestroy() {
    console.log('destroy')
    document.removeEventListener('click', this.outCompanyClick)
  },
  methods: {
    outCompanyClick(event) {
      console.log('event', event)
      if (event.target.id !== 'companyName') {
        this.companyNameListShow = false
        this.companyNameListShowB = false
      }
    },
    searchEnterprise2Fun(type) {
      if (type===1&&this.companyName.length < 3) return;
      if(!type&&this.companyNameB.length < 3)return
      let params;
      if (type===1) {
        // console.log(56789)
        params = {
          key: this.companyName,
        };
        this.oneDis = true
      } else {
        // console.log(567890)
        params = {
          key: this.companyNameB,
        };
        this.twoDis = true
      }
      searchEnterprise2(params).then((res) => {
        if (!params.key) {
          this.listCompany.length = 0;
        }
        if (res.code === "S01") {
          this.listCompany.length = 0;
          this.listCompany = res.results;
        } else if (res.code === "msg") {
          this.isSearchingShow =false
          this.listCompany.length = 0;
        } else {
             this.isSearchingShow =false
            this.getReportType = "alert"
            this.getReportRes = res.message
            this.dialogShow = true
        }
      });
    },
    companyNameFocus(type) {
      this.listCompany.length = 0;
      if (type === 1) {
        this.companyNameListShow = true;
      } else {
        this.companyNameListShowB = true;
      }
    },
    companyNameBlur(type) {
      // if (type === 1) {
      //   setTimeout(() => {
      //     this.companyNameListShow = false;
      //   }, 100);
      // } else {
      //   setTimeout(() => {
      //     this.companyNameListShowB = false;
      //   }, 100);
      // }
    },
    async chooseCompanyName(item, type) {
      this.isSearchingShow = true
      if (type === 1) {
        this.companyName = item.name;
        let params = {
          enterpriseName: item.name,
          enterpriseUnifiedSocialcreditcode: "",
          enterpriseRole: 0,
        };
        this.oneDis = true
        await checkEnterpriseName(params).then(
          (res) => {
             this.isSearchingShow =false
            // console.log("res123", res);
            // console.log("res", res);
            if (res.code === "S01") {
              this.oneDis = false
              this.reportId = res.id;
            } else {
               this.getReportType = "alert"
               this.getReportRes = res.message
               this.dialogShow = true
            }
          },
          (err) => {
            console.log("err", err);
          }
        );
      } else {
        this.companyNameB = item.name;
        let params = {
          enterpriseName: item.name,
          enterpriseUnifiedSocialcreditcode: "",
          enterpriseRole: 0,
        };
         this.twoDis = true;
        await checkEnterpriseName(params).then(
          (res) => {
            this.isSearchingShow =false
            // console.log("res123", res);
            if (res.code === "S01") {
              this.twoDis = false;
              this.reportIdB = res.id;
            } else {
              // console.log('noFind')
              this.getReportType = "alert"
              this.getReportRes = res.message
              this.dialogShow = true
            }
          },
          (err) => {
            console.log("err", err);
          }
        );
      }
    },
    companyNameCompositionstart(type) {
      if (type === 1) {
        // console.log(123);
        this.compositionFlag = true;
      } else {
        this.compositionFlagB = true;
      }
    },
    companyNameCompositionend(type) {
      // console.log(323);
      if (type === 1) {
        if (this.compositionFlag) {
          this.compositionFlag = false;
          this.handleInput(1);
        }
      } else {
        if (this.compositionFlagB) {
          this.compositionFlagB = false;
          this.handleInput();
        }
      }
    },
    companyNameCompositionupdate(type) {
      if (type === 1) {
        let text = this.companyName;
        let lastCharacter = text[text.length - 1] || "";
        this.compositionFlag = !this.isKorean(lastCharacter);
      } else {
        let textB = this.companyNameB;
        let lastCharacterB = textB[textB.length - 1] || "";
        this.compositionFlagB = !this.isKorean(lastCharacterB);
      }
    },
    // newDebounce(type) {
    //   // console.log(223456,type)
    //   debounce(this.searchEnterprise2Fun(type), 300);
    // },
    searchCompany(type) {
      // console.log(123456, type);
      this.newDebounce(type);
    },
    handleInput(type) {
      if (type === 1) {
        // this.oneDis = false
        if (this.compositionFlag) return;
        this.searchCompany(1);
      } else {
        // this.twoDis = false
        if (this.compositionFlagB) return;
        this.searchCompany();
      }
    },
    isKorean(text) {
      var reg = /([(\uAC00-\uD7AF)|(\u3130-\u318F)])+/gi;
      return reg.test(text);
    },
    async downLoadReport(type) { 
      console.log(111,this.$route) 
          // gdt('track', 'SEARCH',{'key1': 'value1', 'key2': 'value2'} );// 搜索
          // gdt('track', 'VIEW_CONTENT', {'key1': 'value1', 'key2': 'value2'});//浏览
          // gdt('track', 'REGISTER', {'key1': 'value1', 'key2': 'value2'});//注册
          // gdt('track', 'ADD_TO_WISHLIST', {'key1': 'value1', 'key2': 'value2'});//收藏
          // gdt('track', 'CONSULT', {'key1': 'value1', 'key2': 'value2'});//咨询
          // gdt('track', 'ADD_TO_CART', {'key1': 'value1', 'key2': 'value2'});//加入购物车
          // gdt('track', 'INITIATE_CHECKOUT', {'key1': 'value1', 'key2': 'value2'});//开始结算
          // gdt('track', 'COMPLETE_ORDER', {'key1': 'value1', 'key2': 'value2'});//下单
          // gdt('track', 'PURCHASE', {'key1': 'value1', 'key2': 'value2'});//付费
          // gdt('track', 'RESERVATION', {'key1': 'value1', 'key2': 'value2'});//预约
          // gdt('track', 'SHARE', {'key1': 'value1', 'key2': 'value2'});//分享
          // gdt('track', 'APPLY', {'key1': 'value1', 'key2': 'value2'});//申请
          // gdt('track', 'CLAIM_OFFER', {'key1': 'value1', 'key2': 'value2'});//领取卡券
          // gdt('track', 'NAVIGATE', {'key1': 'value1', 'key2': 'value2'});//导航
          // gdt('track', 'PRODUCT_RECOMMEND', {'key1': 'value1', 'key2': 'value2'});//商品推荐
          // gdt('track', 'VISIT_STORE', {'key1': 'value1', 'key2': 'value2'});// 到店
          // gdt('track', 'TRY_OUT', {'key1': 'value1', 'key2': 'value2'});// 体验
          // gdt('track', 'DELIVER', {'key1': 'value1', 'key2': 'value2'});// 发货
          // gdt('track', 'SIGN_IN', {'key1': 'value1', 'key2': 'value2'});// 签收
          // gdt('track', 'CONFIRM_EFFECTIVE_LEADS', {'key1': 'value1', 'key2': 'value2'});// 确认有效线索
          // gdt('track', 'CONFIRM_POTENTIAL_CUSTOMER', {'key1': 'value1', 'key2': 'value2'});// 确认潜在客户
          // gdt('track', 'CREATE_ROLE', {'key1': 'value1', 'key2': 'value2'});// 创建角色
          // gdt('track', 'AUTHORIZE', {'key1': 'value1', 'key2': 'value2'});// 授权
          // gdt('track', 'TUTORIAL_FINISH', {'key1': 'value1', 'key2': 'value2'});// 完成新手教程
          // gdt('track', 'SCANCODE', {'key1': 'value1', 'key2': 'value2'});// 扫码
          // gdt('track', 'PRE_CREDIT', {'key1': 'value1', 'key2': 'value2'});// 预授信
          // gdt('track', 'CREDIT', {'key1': 'value1', 'key2': 'value2'});// 授信
          // gdt('track', 'WITHDRAW_DEPOSITS', {'key1': 'value1', 'key2': 'value2'});// 提现
    // gdt('track_custom', 'CUSTOM_ACTION_NAME', {'key1': 'value1', 'key2': 'value2'});


      
      this.loadingShow = true;
      let params
      if(type===1){
        params = {enterpriseId:this.reportId}
      }else{
         params = {enterpriseId:this.reportIdB}
      }    
      params.linkNumber = this.$route.query.n|| ''
       downloadSystemInputReport(params).then(
        (res)=>{
          console.log('this.$route.query.n',this.$route.query.n)
          if(res.code==="S01"){
              let queryParams = {reportId: res.results};
              if(this.$route.query.n){
                queryParams.n = this.$route.query.n||''
              }
              if(this.$route.query.s){
                queryParams.s = this.$route.query.s||''
              }
               this.$router.push({ path: "/reportPage", query: queryParams })
            document.documentElement.scrollTop=0
             }else{
               (this.getReportType = "alert"),
               (this.getReportRes = res.message),
               (this.dialogShow = true);
               this.loadingShow = false;
             }
          },
        (err)=>{console.log(err)})
      // this.$router.push('/reportPage')
      // this.$router.push({ path: "/reportPage", query: { vid: "05517" } });
    },
    dialogGoBack(e) {
      this.dialogShow = e;
    },
  },
  watch: {
    '$store.state.admin.config.isload': function (val) {
      console.log('pageStyleConfig',this.pageStyleConfig,this.pageStyleConfig.shareTItle, this.pageStyleConfig.shareContent,this.pageStyleConfig.sharePic)
       shareImpl({
               shareTitle:this.pageStyleConfig.shareTItle||"要估值，就上模估估",
               shareDesc: this.pageStyleConfig.shareContent||'30秒快速计算企业价值，别让投资人“低估”了你!',
               shareUrl: location.href,
              //  shareImg: 'https://rdt.h5.mogugu.com/static/img/bannerBottom.ef9f362.jpg'
              shareImg:this.pageStyleConfig.sharePic||'https://s2.loli.net/2022/05/01/judNJWZIR3PqfwD.png'
                    })
      //  shareImpl({
      //          shareTitle:"要估值，就上模估估",
      //          shareDesc: '30秒快速计算企业价值，别让投资人“低估”了你!',
      //          shareUrl: location.href,
      //         //  shareImg: 'https://rdt.h5.mogugu.com/static/img/bannerBottom.ef9f362.jpg'
      //         shareImg:'https://s2.loli.net/2022/05/01/judNJWZIR3PqfwD.png'
      //               })
    },
  },
  computed:{
    pageStyleConfig(){
     return this.$store.state.admin.config
    }
  },

};
</script>

<style lang='less'>
.chooseCompanyWrapper{
  height:100vh;
  overflow: auto;
  position: relative;
.chooseCompany {
  width: 100%;
}

.logoBanerWrapper {
  width: 100%；;
}
.logoBanner {
  width: 100%;
  height: auto;
  display:block;
}
.inputContainerWrapperBlock{
  background-size: 100% 100%;
// border:1px solid transparent;
float:left;
width:100%;
}
.inputContainerWrapper{
// overflow:hidden;
  }
.inputContainer {
  width: calc(100% - 0.6rem);
  margin: 0.6rem auto 0.3rem;
  position: relative;
}
.inputInnerContainer {
  margin: 0.36rem 0 0.3rem 0;
  // background-color: #f3f5ff;
  background-color:var(--inputBgColor);
  height: 0.88rem;
  line-height: 0.88rem;
}
.input-label {
  font-size: 0.26rem;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: left;
  // color: #969caa;
  color: var(--inputColor);
  float: left;
  margin-left: 0.3rem;
}
.companyWrapeper {
  float: right;
}

.company-name {
  text-align: right;
  width: 3.9rem;
  margin-right: 0.3rem;
  float: right;
  font-size: 0.26rem;
  border: none;
  background-color: #f3f5ff;
  background-color:var(--inputBgColor);
  // color: #5883ff;
  color:var(--placeColor);

}
.company-name::placeholder{
  color:var(--placeColor);
}
.companyList {
  box-sizing: border-box;
  padding: 0.15rem 0;
  background-color: #fff;
  position: absolute;
  top: 0.88rem;
  left: 0;
  font-size: 0.3rem;
  text-align: right;
  width: 100%;
  max-height:3.65rem;
  // line-height: 0.52rem;
  max-height: 3.6rem;
  overflow-y: auto;
}
.companyItem{
  margin-right:0.15rem;
  font-size:0.26rem;
  padding:0.15rem;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: right;
  color: #222222;
}
.downloadBtn {
  border: 0;
  display: block;
  width: calc(100% - 0.6rem);
  margin: 0 auto;
  line-height: 0.88rem;
  font-size: 0.3rem;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: center;
  // color: #ffffff;
  color:var(--buttonTxtColor);
  // background-color: #5883ff;
  background-color:var(--buttonColor);
}
.linear{
  // background: linear-gradient(269deg,#397bf9 1%, #004add 99%)!important;
}
.alreadyVal {
  font-size: 0.36rem;
  width:2.97rem;
  margin: 0.3rem auto 0.6rem;
  height:auto;
}
.alreaadyValPic{
  width:100%;
  height: auto;
}
.valuationToMogugu{
  width:100%;
  height:auto;
  display:block;
}
.problem {
  // background-color: #f7f7f7;
  // overflow: hidden;
  box-sizing: border-box;
  // padding: 0 0.3rem;
}
.problemuse{
  box-sizing: border-box;
}
.spin {
  width: 100%;
  height: 100%;
}
.problemTittle {
  font-size: 0.48rem;
  font-family: PingFang SC, PingFang SC-Bold;
  font-weight: 700;
  margin: 0.6rem auto 0.2rem;
  text-align: center;
}
.grayColor {
  color: #222;
}
.blueColor {
  color: #5883ff;
}
.problemEn {
  background-color: #5883ff;
  font-size: 0.22rem;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: center;
  color: #ffffff;
  width: 5.6rem;
  margin: 0.2rem auto 0.36rem;
  border-radius: 0.08rem;
  line-height: 0.52rem;
}
.problemPer {
  width: 3.38rem;
}
.perImg {
  float: right;
}
.problemText {
  width: 3.21rem;
  text-align: center;
  font-size: 0.36rem;
  font-family: PingFang SC, PingFang SC-Bold;
  font-weight: 700;
  color: #222222;
  line-height: 0.88rem;
  float: left;
}
.textBlock {
  background-color: #fff;
}
.marginBto {
  margin-bottom: 0.3rem;
}
.aboutMogugu {
  overflow: hidden;
  box-sizing: border-box;
  padding: 0 0.3rem;
  height: 4.02rem;
  width: 100%;
  background-color: #5883ff;
}
.VSBlock {
  overflow: hidden;
  box-sizing: border-box;
  padding: 0 0.2rem;
}
.VStitle {
  font-size: 0.48rem;
  font-family: PingFang SC, PingFang SC-Bold;
  font-weight: 700;
  margin: 0.6rem auto 0.2rem;
  text-align: center;
  color: #222222;
}
.vsTip {
  font-size: 0.32rem;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: center;
  color: #ffffff;
  line-height: 0.52rem;
  background-color: #5883ff;
  padding: 0 0.27rem;
  border-radius: 0.08rem;
}
.vsTipL{
  font-size: 0.32rem;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: center;
  color: #ffffff;
  line-height: 0.52rem;
  background-color: #999;
  padding: 0 0.27rem;
  border-radius: 0.08rem;
}
.grayColor{
  color: #999 !important;;
}

.vsTipWrapper {
  height: 0.52rem;
  margin-bottom: 0.3rem;
  display: flex;
  font-size: 0.54rem;;
}
.vsleft {
  // float: left;
  flex:1.74;
  // text-align: center;
  display: flex;
  justify-content: center;
}
.vscenter{
  flex:0.8;
}
.vsright {
  // float: right;
  flex:1.74;
  display: flex;
  justify-content: center;
}
.vsContent {
  display: flex;
}
.vsContentItem {
  flex: 1.74;
  text-align: center;
}
.vsContentItemCenter {
  flex: 0.8;
  position: relative;
}
.vsImgC {
  width: 0.79rem;
}
.vsImgWrapper {
  text-align: center;
}
.vsImgTitle {
  font-size: 0.26rem;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: center;
  color: #222222;
  margin-bottom: 0.07rem;
}
.vsImgSpeak {
  font-size: 0.2rem;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: center;
  color: #222222;
}
.marBto36 {
  margin-bottom: 0.36rem;
}
.vsContentImg {
  width: 100%;
  position: absolute;
  top: 50%;
  margin-top: -1.3rem;
}
.vsCenterV {
  position: absolute;
  top: 10%;
  text-align: center;
  width: 100%;
  font-size: 0.48rem;
  font-family: Alibaba PuHuiTi, Alibaba PuHuiTi-Heavy;
  font-weight: 800;
}
.vsCenterS {
  position: absolute;
  bottom: 20%;
  text-align: center;
  width: 100%;
  font-size: 0.48rem;
  font-family: Alibaba PuHuiTi, Alibaba PuHuiTi-Heavy;
  font-weight: 800;
}
.reportBlock {
  background-color: #5883ff;
  overflow: hidden;
}
.reportTitle {
  margin-top: 0.6rem;
  margin-bottom: 0.3rem;
  font-size: 0.48rem;
  font-family: PingFang SC, PingFang SC-Bold;
  font-weight: 700;
  color: #ffffff;
  text-align: center;
}
.reportPicWrapper {
  width: 6.9rem;
  margin: 0 auto;
  padding-bottom: 0.62rem;
}
.reportPic {
  width: 100%;
  height: auto;
  padding:0.3rem;
  background-color: #fff;
  box-sizing: border-box;
  border-radius:0.16rem;

}
.wxReportExample {
  overflow: hidden;
}
.reportExampleTitle {
  font-size: 0.48rem;
  font-family: PingFang SC, PingFang SC-Bold;
  font-weight: 700;
  text-align: center;
  color: #222222;
  margin: 0.6rem 0 0.3rem 0;
}
.reportExample {
  width: 6.9rem;
  height: auto;
  margin: 0 auto;
}
.wxReport {
  width: 100%;
}
.bottomBannerWrapper{
  display: block;
  width:6.9rem;
  margin:0.6rem auto 0.2rem;
  border-radius: 0.16rem;
  overflow: hidden;
}
.bannerBottomImg{
  width:100%;
  display: block;
}
.twoCodeBlock {
  overflow: hidden;
}
.twoCodeTitle {
  margin: 0.6rem 0 0.24rem 0;
  font-size: 0.48rem;
  font-family: PingFang SC, PingFang SC-Bold;
  font-weight: 700;
  text-align: center;
  color: #222222;
}
.twoCode {
  width: 2.22rem;
  margin: 0 auto;
}
.twoCodeImg {
  width: 100%;
}
.fllow {
  font-size: 0.24rem;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: center;
  color: #222222;
}
.aboutMogugu {
  background-color: #5883ff;
}
.aboutmoguguImgWrapper {
  width: 6.9rem;
  height: auto;
  margin: 0.54rem auto 0.6rem;
}
.aboutmoguguImg {
  width: 100%;
}
.moreBlock{
 height:2.8rem;
}
.linkSpeakWrap{
  display: block;
  // position: relative;
  text-align: center;
  font-size: 0.37rem;
  margin-bottom: 0.61rem;
}
.pointTwo{
  position: absolute;
  width:0.3rem;
  height:auto;
  left: 0;
  top:0;
}
.linkSpeak{
height: 0.37rem;
font-size: 0.26rem;
font-family: PingFang SC, PingFang SC-Regular;
font-weight: 400;
text-align: center;
color: #f1781b;
line-height: 0.3rem;
display: inline-block;
position: relative;
padding-left: 0.3rem;
}
.relateUs{
font-size: 0.48rem;
font-family: PingFang SC, PingFang SC-Bold;
font-weight: 700;
text-align: center;
}
.relatePicWrapper{
  text-align: center;
  height:0.73rem;
  font-size: 0.56rem;
  padding-top: 0.2rem;
  padding-left: 0.56rem;;
}
.relatePic{
height: 0.56rem;
width:auto;
position: absolute;
top:0rem;
left:-0.7rem;
}
.telNumber{
  display: inline-block;
  font-size: 0.46rem; 
  line-height: 0.56rem;
  color:#5883FF;
  font-family: PingFang SC, PingFang SC-Bold;
font-weight: 500;
}
.hotLine{
  display: inline-block;
  font-size: 0.46rem; 
  line-height:0.56rem; 
  position: relative;
  font-family: PingFang SC, PingFang SC-Bold;
font-weight: 500;
}
.welcomeTel{
  padding-top:0.21rem;
  padding-bottom: 0.61rem;
  font-size: 0.24rem;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: center;
  color: #222222;
}
.point{
  font-size: 0.40rem;
}
.pointImg{
  height: 0.47rem;
  padding-right: 0.03rem;
  vertical-align: middle;
}
.plus{
  color:#FFDD00!important;
font-weight: 700;

  }
.oneKey{
  line-height: 0.67rem;
font-size: 0.48rem;
font-family: PingFang SC, PingFang SC-Bold;
// text-align: left;
color: #ffffff;
font-family: PingFang SC, PingFang SC-Bold;
font-weight: 700;
}
.bottomButtonbg{
  overflow:hidden;
  background-size:100% 100%;
}

}
</style>



// WEBPACK FOOTER //
// src/pages/chooseCompany/chooseCompany.vue